<div class="login-wrap">
  <ng-container *ngIf="user$ | async as user; else showAuth">
    <h2>Welcome, {{ user.email }}</h2>
    <button (click)="logout()" class="logout-btn">Logout</button>
    <button routerLink="/workout-tracker" class="login-btn" style="margin-top:1rem;">Go to Workout Tracker</button>
  </ng-container>
  <ng-template #showAuth>
    <h2 *ngIf="showLogin">Login</h2>
    <h2 *ngIf="!showLogin">Sign Up</h2>
    <form *ngIf="showLogin" (submit)="login(email.value, password.value); $event.preventDefault()" class="login-form">
      <input #email type="email" placeholder="Email" required class="login-input">
      <input #password type="password" placeholder="Password" required class="login-input">
      <button type="submit" class="login-btn">Login</button>
    </form>
    <form *ngIf="!showLogin" (submit)="signup(signupEmail.value, signupPassword.value); $event.preventDefault()" class="login-form">
      <input #signupEmail type="email" placeholder="Email" required class="login-input">
      <input #signupPassword type="password" placeholder="Password" required class="login-input">
      <button type="submit" class="login-btn">Sign Up</button>
    </form>
    <button (click)="showLogin = !showLogin" class="toggle-btn">
      {{ showLogin ? 'Need an account? Sign Up' : 'Already have an account? Login' }}
    </button>
  </ng-template>
</div>
